export const NO_CLEAR_BUY_DOWN_TYPE_FOUND = 'No clear buy down type found'
export const THREE_TWO_ONE = '3-2-1'
export const TWO_ONE = '2-1'
export const ONE_ONE = '1-1'
export const ONE_ZERO = '1-0'

export const BUY_DOWN_VALUES = [THREE_TWO_ONE, TWO_ONE, ONE_ONE, ONE_ZERO, NO_CLEAR_BUY_DOWN_TYPE_FOUND] as const

export type BUY_DOWN_TYPE = (typeof BUY_DOWN_VALUES)[number]

export const BUY_DOWN_MAPPINGS = {
  [THREE_TWO_ONE]: [
    { year: '1', rateDrop: 3 },
    { year: '2', rateDrop: 2 },
    { year: '3', rateDrop: 1 },
    { year: '4', rateDrop: 0 }
  ],
  [TWO_ONE]: [
    { year: '1', rateDrop: 2 },
    { year: '2', rateDrop: 1 },
    { year: '3', rateDrop: 0 }
  ],
  [ONE_ONE]: [
    { year: '1', rateDrop: 1 },
    { year: '2', rateDrop: 1 },
    { year: '3', rateDrop: 0 }
  ],
  [ONE_ZERO]: [
    { year: '1', rateDrop: 1 },
    { year: '2', rateDrop: 0 }
  ]
}
